/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 * @see https://github.com/jakearchibald/idb
 */

import { openDB } from 'idb'
import moment from 'moment'

const version = 14

export default {

  open () {
    return openDB('handy', version, {
      upgrade(db, oldVersion, newVersion, transaction) {
        switch(oldVersion) {
          case 0:
            db.createObjectStore('logs', { autoIncrement: true })
          case 1:
            db.createObjectStore('Business', { keyPath: 'id' })
            db.createObjectStore('Cashier', { keyPath: 'id' })
            db.createObjectStore('Combination', { keyPath: 'id' })
            db.createObjectStore('CombinationPivot', { keyPath: 'id' })
            db.createObjectStore('Discount', { keyPath: 'id' })
            db.createObjectStore('DishOrder', { keyPath: 'id' })
            db.createObjectStore('Integration', { keyPath: 'id' })
            db.createObjectStore('ItemSellingFormatPivot', { keyPath: 'id' })
            db.createObjectStore('LinkedItemPivot', { keyPath: 'id' })
            db.createObjectStore('MenuCategory', { keyPath: 'id' })
            db.createObjectStore('MenuGroup', { keyPath: 'id' })
            db.createObjectStore('MenuItem', { keyPath: 'id' })
            db.createObjectStore('MenuMenuCategory', { keyPath: 'id' })
            db.createObjectStore('MenuMenuPivot', { keyPath: 'id' })
            db.createObjectStore('Modifier', { keyPath: 'id' })
            db.createObjectStore('ModifierCategory', { keyPath: 'id' })
            db.createObjectStore('ModifierGroup', { keyPath: 'id' })
            db.createObjectStore('ModifierPivot', { keyPath: 'id' })
            db.createObjectStore('OrderConfig', { keyPath: 'id' })
            db.createObjectStore('PaymentMethod', { keyPath: 'id' })
            db.createObjectStore('Permission', { keyPath: 'id' })
            db.createObjectStore('PrintTicket', { keyPath: 'id' })
            db.createObjectStore('SellingFormat', { keyPath: 'id' })
            db.createObjectStore('TableRoom', { keyPath: 'id' })
            db.createObjectStore('TableTable', { keyPath: 'id' })
            db.createObjectStore('Tax', { keyPath: 'id' })
            db.createObjectStore('TenantUser', { keyPath: 'id' })
          case 2:
            db.createObjectStore('checksums', { keyPath: 'model' })
          case 3:
            db.createObjectStore('auth')
          case 4:
            db.deleteObjectStore('auth')
            db.createObjectStore('keyval')
          case 5:
            db.createObjectStore('FiscalSettings', { keyPath: 'id' })
          case 6:
            db.deleteObjectStore('Integration')
          case 7:
            db.createObjectStore('Integration', { keyPath: 'id' })
          case 8:
            db.createObjectStore('TablePrice', { keyPath: 'id' })
            db.createObjectStore('ItemPricePivot', { keyPath: 'id' })
          case 9:
            db.deleteObjectStore('Combination')
            db.deleteObjectStore('CombinationPivot')
            db.createObjectStore('CombinationGroupMenuItem', { keyPath: 'id' })
            // sync combinations
            const lastSync = moment.utc(window.localStorage.getItem('syncFrom') || '1977-03-24 09:00:00', 'YYYY-MM-DD HH:mm:ss', true)
            const combinationsRefactor = moment.utc('2024-04-23 09:00:00', 'YYYY-MM-DD HH:mm:ss', true)
            const syncFrom = moment.min(lastSync, combinationsRefactor)
            window.localStorage.setItem('syncFrom', syncFrom.format('YYYY-MM-DD HH:mm:ss'))
          case 10:
            db.createObjectStore('Price', { keyPath: 'id' })
            db.deleteObjectStore('ItemPricePivot')
          case 11:
            db.createObjectStore('Customer', { keyPath: 'id' })
          case 12:
            db.createObjectStore('KitchenNote', { keyPath: 'id' })
          case 13:
            db.deleteObjectStore('checksums')
            db.createObjectStore('checksum')
        }
      },
      blocked() {
        console.warn('IndexedDB blocked')
      },
      blocking() {
        console.warn('IndexedDB blocking')
      },
      terminated() {
        window.localStorage.removeItem('syncFrom')
        console.warn('IndexedDB terminated')
      },
    })
  },

  async truncate (db) {
    window.localStorage.removeItem('syncFrom') // it must be the first action
    db = db ?? await this.open()
    for (const objectStore of db.objectStoreNames) {
      await db.clear(objectStore)
    }
  },

}
